import React from "react";
import { ModalBody, Modal } from "reactstrap";
import styles from "./addspots.module.scss";
import Proptypes from "prop-types";
import { toast } from "react-toastify";
import { addSpots, getLocations } from "../../../../helpers/service";
import { useFormik } from "formik";
import * as yup from "yup";
import Textfield from "../../../Shared/Textfield";
import { useDispatch, useSelector } from "react-redux";
import { setLocations } from "../../../Redux/Reducer/appReducer";

const AddSpotsSchema = yup.object().shape({
  name: yup.string().required("Required"),
  specificationNumber: yup.string().required("Required"),
});

const AddSpotsModal = ({ openModal, toggle, locationId, setLoading }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.authReducer);
  const { brands } = useSelector((state) => state.appReducer);

  const initialState = {
    locationId,
    name: "",
    specificationNumber: "",
  };

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: AddSpotsSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const locationUpdate = async (locations) => {
    const isAdmin = userData?.role === "admin";
    const filteredLocations = isAdmin
      ? locations
      : locations.filter((location) =>
          brands?.some(
            (brand) =>
              brand?.id === location?.brandId && brand?.userId === userData.id
          )
        );

    dispatch(setLocations(filteredLocations));
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const spotsData = await addSpots(values, userData?.idToken);

      if (spotsData?.locationId) {
        const locations = await getLocations(userData?.idToken);
        locationUpdate(locations);
      }

      setLoading(false);
      formik.resetForm();
      toast.success("Spot added successfully");
      formik.setSubmitting(false);
      toggle();
    } catch {
      toast.error("Something went wrong. Please try again.");
      formik.setSubmitting(false);
    }
  };
  return (
    <Modal
      isOpen={openModal}
      toggle={() => {
        formik.resetForm();
        toggle();
      }}
      centered
      fullscreen="sm"
      contentClassName={styles["modal_content"]}
      className={styles["container"]}
      wrapClassName={styles["modal_wrapper"]}
      backdropClassName={styles["modal-backdrop-style"]}
    >
      <ModalBody className={styles["modal_body"]}>
        <div>
          <p className={styles["modal_heading"]}>Add a Spot</p>
        </div>
        <div>
          <p className={styles["modal_paragraph"]}>
            A Spot is a specific place in a Location, such as a receiving area,
            a conveyor belt, or a supply closet. Name Spots whatever you like;
            the names are only visible to you and Lumi. If you don&apos;t need
            to track Spots, just leave this blank
          </p>
        </div>
        <div
          style={{
            marginTop: "24px",
            marginBottom: "10px",
          }}
        >
          <Textfield
            name="name"
            id="name"
            onChange={formik.handleChange}
            placeholder="Name"
            className={styles["input_field_styles"]}
            error={formik?.errors?.name}
            touched={formik?.touched?.name}
          />
        </div>
        <div
          style={{
            marginBottom: "20px",
          }}
        >
          <Textfield
            name="specificationNumber"
            id="specificationNumber"
            onChange={formik.handleChange}
            placeholder="Serial Number"
            className={styles["input_field_styles"]}
            error={formik?.errors?.specificationNumber}
            touched={formik?.touched?.specificationNumber}
          />
        </div>
        <div className={styles["submit_btns"]}>
          <div className={styles["button_div"]}>
            <button
              className={styles["button_style_cancel"]}
              onClick={() => {
                toggle();
              }}
            >
              Cancel
            </button>
          </div>
          <div className={styles["button_div"]}>
            <button
              className={styles["button_style_add"]}
              onClick={() => {
                formik.handleSubmit();
              }}
              disabled={formik.isSubmitting}
            >
              Add Spot
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

AddSpotsModal.propTypes = {
  openModal: Proptypes.bool,
  toggle: Proptypes.func,
  locationId: Proptypes.string,
  spotsNames: Proptypes.string,
  setSpotsNames: Proptypes.func,
};

export default AddSpotsModal;
